<ng-container *ngIf="vm$ | async as vm">
  <div class="catalogs-root" [ngStyle]="getThemeStyles(vm.config)">
    <div class="master-detail-layout" [class.sidebar-collapsed]="vm.sidebarCollapsed">
      <app-catalog-side-panel
        [title]="vm.config?.title || 'Domain Catalogs'"
        [subtitle]="vm.config?.subtitle || ''"
        [items]="vm.navItems"
        [activeId]="getNavActiveId(vm)"
        [pendingCounts]="vm.pendingCounts"
        [canAddCatalog]="false"
        [hoverSelection]="hoverSelection"
        (select)="selectCatalog($event)"
        (addCatalog)="catalogs.openAddCatalogModal()"
        (remove)="catalogs.removeAddedCatalog($event)"
      ></app-catalog-side-panel>

      <main class="main-area">
        <div class="detail-content" *ngIf="vm.config as config">
          <ng-container *ngIf="catalogs.activeConfig as activeConfig">
            <app-catalog-page-header
              [title]="getTabParent(vm)?.title || activeConfig.title"
              (toggleSidebar)="catalogs.toggleSidebar()"
              (refresh)="refreshCatalog()"
            ></app-catalog-page-header>

            <div class="catalog-tab-header" role="tablist" *ngIf="getTabParent(vm) as tabParent">
              <button
                type="button"
                role="tab"
                class="catalog-tab"
                *ngFor="let tab of tabParent.tabs"
                [class.active]="tab.id === vm.activeCatalogId"
                [attr.aria-selected]="tab.id === vm.activeCatalogId"
                (click)="selectCatalog(tab.id)"
              >
                {{ tab.label }}
              </button>
            </div>

            <app-catalog-doa-range-form
              *ngIf="!vm.sidebarCollapsed && showDoaRangeForm(vm)"
              [businessUnitOptions]="getDoaBusinessUnits(vm)"
              [recordCount]="vm.filteredRows.length"
              [editValue]="doaRangeEditValue"
              (save)="saveDoaRange($event)"
              (formReset)="cancelDoaEdit()"
            ></app-catalog-doa-range-form>

            <app-catalog-doa-approver-form
              *ngIf="!vm.sidebarCollapsed && showDoaApproverForm(vm)"
              [businessUnitOptions]="getDoaBusinessUnits(vm)"
              [regionOptions]="getDoaRegions(vm)"
              [recordCount]="vm.filteredRows.length"
              [editValue]="doaApproverEditValue"
              (save)="saveDoaApprover($event)"
              (formReset)="cancelDoaEdit()"
            ></app-catalog-doa-approver-form>

            <app-catalog-filter-panel
              *ngIf="!vm.sidebarCollapsed && !showDoaRangeForm(vm) && !showDoaApproverForm(vm)"
              [filters]="activeConfig.filters"
              [values]="vm.filters"
              [recordCount]="vm.filteredRows.length"
              (filterChange)="catalogs.setFilter($event.key, $event.value)"
              (resetFilters)="catalogs.clearFilters()"
            ></app-catalog-filter-panel>

            <app-catalog-table
              [title]="activeConfig.title"
              [addButtonLabel]="activeConfig.addButtonLabel"
              [columns]="activeConfig.columns"
              [rows]="vm.filteredRows"
              [loading]="vm.loading"
              [selectedRowId]="vm.selectedRowId"
              [editingIds]="vm.editingIds"
              [editValues]="vm.editValues"
              [pendingDeleteIds]="vm.pendingDeleteIds"
              [pendingInsertIds]="vm.pendingInsertIds"
              [pendingToggleIds]="vm.pendingToggleIds"
              [pendingChangeCount]="getPendingChangeCount(vm)"
              [isAdding]="vm.isAdding"
              [draftRow]="vm.draftRow"
              [draftSelectOptions]="getDraftSelectOptions(vm.activeCatalogId)"
              [uiConfig]="getTableUiConfig(vm)"
              [quickFilters]="getTableQuickFilters(vm)"
              [filterValues]="vm.filters"
              (filterChange)="catalogs.setFilter($event.key, $event.value)"
              (resetFilters)="catalogs.clearFilters()"
              (rowClick)="catalogs.toggleRowSelection($event)"
              (addRow)="catalogs.startAddRow()"
              (commitAdd)="catalogs.commitAddRow()"
              (cancelAdd)="catalogs.cancelAddRow()"
              (editToggle)="editRow(vm, $event)"
              (activeToggle)="catalogs.toggleActive($event)"
              (deleteRow)="catalogs.deleteRow($event)"
              (saveAll)="catalogs.saveAll()"
              (discardChanges)="catalogs.discardChanges()"
            ></app-catalog-table>
          </ng-container>
        </div>
      </main>
    </div>

    <div *ngIf="vm.toastVisible" class="toast-layer" aria-live="polite" aria-atomic="true">
      <div class="toast-popup" [class.visible]="vm.toastVisible" [attr.data-variant]="vm.toastVariant" role="status">
        <span class="toast-icon" aria-hidden="true">
          <svg *ngIf="vm.toastVariant !== 'error'" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4">
            <path d="M20 6 9 17l-5-5"></path>
          </svg>
          <svg *ngIf="vm.toastVariant === 'error'" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </span>
        <span class="toast-message">{{ vm.toastMessage }}</span>
      </div>
    </div>

    <div class="modal-backdrop" *ngIf="vm.showAddCatalogModal" (click)="catalogs.closeAddCatalogModal()">
      <div class="add-catalog-modal" (click)="$event.stopPropagation()">
        <div class="modal-hdr">
          <h4>Add New Catalog</h4>
          <button type="button" class="modal-close-btn" (click)="catalogs.closeAddCatalogModal()">x</button>
        </div>

        <div class="modal-body">
          <div class="modal-field">
            <label>Catalog Options</label>
            <select
              class="modal-select"
              [ngModel]="vm.newCatalogType"
              (ngModelChange)="catalogs.setNewCatalogType($event)"
            >
              <option value="" disabled>- Select a catalog -</option>
              <option *ngFor="let catalog of vm.availableCatalogTypes" [value]="catalog.id">
                {{ catalog.label }}
              </option>
            </select>
          </div>

          <p class="modal-hint" *ngIf="vm.newCatalogType">
            {{ catalogs.getCatalogDescription(vm.newCatalogType) }}
          </p>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn-modal-cancel" (click)="catalogs.closeAddCatalogModal()">Cancel</button>
          <button type="button" class="btn-modal-confirm" (click)="catalogs.addCatalog()">Add Catalog</button>
        </div>
      </div>
    </div>

    <div
      class="modal-backdrop"
      *ngIf="vm.showDeleteConfirmModal"
      (click)="catalogs.cancelDeleteConfirm()"
    >
      <div
        class="delete-confirm-modal"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="delete-confirm-title"
        aria-describedby="delete-confirm-desc"
        (click)="$event.stopPropagation()"
      >
        <div class="delete-confirm-body">
          <span class="delete-confirm-icon" aria-hidden="true">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M3 6h18"></path>
              <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
              <path d="M19 6l-1 14H6L5 6"></path>
              <line x1="10" y1="11" x2="10" y2="17"></line>
              <line x1="14" y1="11" x2="14" y2="17"></line>
            </svg>
          </span>
          <div class="delete-confirm-text">
            <h4 id="delete-confirm-title">Delete Record?</h4>
            <p id="delete-confirm-desc">Are you sure you want to delete this record? This action cannot be undone.</p>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn-modal-cancel" #deleteCancelBtn (click)="catalogs.cancelDeleteConfirm()">Cancel</button>
          <button type="button" class="btn-modal-delete" (click)="catalogs.confirmDeleteRow()">Delete</button>
        </div>
      </div>
    </div>
  </div>
</ng-container>
